import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import NewsletterSection from '../components/NewsletterSection';
import Footer from '../components/Footer';
import ChatbotWidget from '../components/ChatbotWidget';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await axios.get(`${API}/settings/privacy_policy`);
      setContent(response.data.setting_value);
    } catch (error) {
      console.error('Failed to fetch privacy policy:', error);
      setContent('Privacy Policy content not available.');
    } finally {
      setLoading(false);
    }
  };

  // Simple Markdown parser for basic formatting
  const parseMarkdown = (text) => {
    if (!text) return '';
    
    return text
      // Headers
      .replace(/^### (.*$)/gim, '<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '<h1>$1</h1>')
      // Bold
      .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
      // Italic
      .replace(/\*(.*?)\*/gim, '<em>$1</em>')
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/gim, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
      // Line breaks
      .replace(/\n\n/gim, '</p><p>')
      .replace(/\n/gim, '<br />');
  };

  if (loading) {
    return (
      <>
        <Header />
        <div style={{ 
          minHeight: '60vh', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <p className="body-medium">Loading...</p>
        </div>
        <Footer />
        <ChatbotWidget />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="privacy-policy-page">
        <div className="container">
          <div className="privacy-content">
            <div 
              className="markdown-content"
              dangerouslySetInnerHTML={{ __html: `<p>${parseMarkdown(content)}</p>` }}
            />
          </div>
        </div>
      </div>
      <NewsletterSection />
      <Footer />
      <ChatbotWidget />
    </>
  );
};

export default PrivacyPolicy;
